import { defineMessage } from 'services/localization';

export const messages = {
    header: defineMessage('contact_information_2'),
    phoneNumber: defineMessage('phone_1'),
    fax: defineMessage('fax'),
    mobile: defineMessage('mobile'),
    directDial: defineMessage('direct_dial'),
    skype: defineMessage('skype_namenumber'),
};
